module.exports = {
  __depends__: [
    require(206)
  ],
  __init__: [ 'labelSupport'],
  labelSupport: [ 'type', require(173) ]
};
